import { AggregationModel } from "domains/models/AggregationModel";
import { ConfigDocModel } from "domains/models/ConfigDocModel";
import { UserModel } from "domains/models/UserModel";
import M5APIs, { M5DocResponse } from "m5/M5APIs";
import { M5Doc } from "m5/models/M5Doc";
import { makeAutoObservable } from "mobx";
import { clearPersistedStore, makePersistable } from "mobx-persist-store";
import * as config from "../../../_config";

export class LoginStore {
  _accessToken?: string;
  _refreshToken?: string;
  _currentUser?: UserModel;
  _accessTokenForM365?: string;
  _refreshTokenForM365?: string;
  _isPublic?: boolean;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    makePersistable(this, {
      name: "PAS",
      properties: ["_currentUser", "_accessToken"],
      storage: window.localStorage,
    });
  }

  get currentUser() {
    return this._currentUser;
  }

  get isPublic() {
    return this._isPublic;
  }

  async defaultDownPeerSetting(user: UserModel) {
    console.log(user);

    if (
      !user.userData.downwardsList ||
      user.userData.downwardsList?.length === 0
    ) {
      if (user.userData.jobTitleRank! === 11) {
        const response2 = await M5APIs.fetchUsers({
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "userData.`deptCode`",
                compare: "=",
                value: user.userData.deptCode,
              },
              // {
              //   condition: "AND",
              //   field: "userData.`deptList[]`",
              //   compare: "IN",
              //   value: [user.userData.deptCode],
              // },
              // {
              //   condition: "AND",
              //   field: "ARRAY_COUNT(userData.`deptList`)",
              //   compare: ">",
              //   value: user.userData.deptList.length,
              // },
            ],
          }),
        });
        console.log(response2);
        response2.users = response2.users.filter(
          (elUser: any) => elUser.id !== user.id
        );
        console.log(response2.users);
        const downWardsIdList = response2.users
          .map((elUser: any) => {
            if (user.id !== elUser.id) {
              return {
                startedOn: "2023-01-03",
                id: elUser.id,
              };
            }
          })
          .filter((el: any) => el !== undefined);
        console.log(downWardsIdList);

        // let params = {
        //   ...user,
        //   userData: {
        //     ...user.userData,
        //     downwardsList: downWardsIdList,
        //   },
        // };
        // const res = await M5APIs.updateMyInfo(params);
        // console.log("res:", res.data.my);
        // this._currentUser = res.data.my;
      } else if (user.userData.jobTitleRank! < 11) {
        const response2 = await M5APIs.fetchUsers({
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "userData.`deptList[]`",
                compare: "IN",
                value: [user.userData.deptCode],
              },
              {
                condition: "AND",
                field: "ARRAY_COUNT(userData.`deptList`)",
                compare: ">",
                value: user.userData.deptList!.length,
              },
            ],
          }),
        });
        const downWardsIdList = response2.users
          .map((elUser: any) => {
            if (user.id !== elUser.id) {
              return {
                startedOn: "2023-01-03",
                id: elUser.id,
              };
            }
          })
          .filter((el: any) => el !== undefined);
        console.log(downWardsIdList);

        // let params = {
        //   ...user,
        //   userData: {
        //     ...user.userData,
        //     downwardsList: downWardsIdList,
        //   },
        // };
        // const res = await M5APIs.updateMyInfo(params);
        // console.log("res:", res.data.my);
        // this._currentUser = res.data.my;
      }
    }
    if (!user.userData.peerList || user.userData.peerList?.length === 0) {
      const response = await M5APIs.fetchUsers({
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "userData.`deptCode`",
              compare: "=",
              value: user.userData.deptCode,
            },
          ],
        }),
      });
      const peerIdList = response.users
        .map((elUser: any) => {
          if (user.id !== elUser.id) {
            return {
              startedOn: "2023-01-03",
              id: elUser.id,
            };
          }
        })
        .filter((el: any) => el !== undefined);
      console.log(peerIdList);

      let params = {
        ...user,
        userData: {
          ...user.userData,
          peerList: peerIdList,
        },
      };
      const res = await M5APIs.updateMyInfo(params);
      console.log("res:", res.data.my);
      this._currentUser = res.data.my;
    }

    // if (
    //   user.userData.deptList?.length === 1 ||
    //   user.userData.deptList?.length === 2
    // ) {
    //   const response2 = await M5APIs.fetchUsers({
    //     page: 0,
    //     pageSize: 20000,
    //     where: JSON.stringify({
    //       filters: [
    //         {
    //           condition: "AND",
    //           field: "userData.`deptList[]`",
    //           compare: "IN",
    //           value: [user.userData.deptCode],
    //         },
    //         {
    //           condition: "AND",
    //           field: "ARRAY_COUNT(userData.`deptList`)",
    //           compare: ">",
    //           value: user.userData.deptList.length,
    //         },
    //       ],
    //     }),
    //   });
    //   console.log(response2);

    //   const downWardsIdList = response2.users
    //     .map((elUser: any) => {
    //       if (user.id !== elUser.id) {
    //         return {
    //           startedOn: "2023-01-03",
    //           id: elUser.id,
    //         };
    //       }
    //     })
    //     .filter((el: any) => el !== undefined);
    //   console.log(downWardsIdList);

    //   let params = {
    //     ...user,
    //     userData: {
    //       ...user.userData,
    //       downwardsList: downWardsIdList,
    //     },
    //   };
    //   const res = await M5APIs.updateMyInfo(params);
    //   console.log("res:", res.data.my);
    //   this._currentUser = res.data.my;
    // } else if (
    //   user.userData.deptList?.length === 3 ||
    //   user.userData.deptList?.length === 4
    // ) {
  }

  async onLogin(username: string, password: string) {
    return await M5APIs.login(username, password);
  }

  async onLoginByGraphId(graphId: string, password: string) {
    return await M5APIs.loginByGraphId(graphId, password);
  }

  async onLoginByEmail(email: string, password: string) {
    return await M5APIs.loginByEmail(email, password);
  }

  setCurrentUser(user: any, accessToken?: string, refreshToken?: string) {
    this._currentUser = user;
    this._accessToken = accessToken;
    this._refreshToken = refreshToken;
    console.log("LOGIN", this._currentUser);
  }

  setCurrentUserForM365(
    user: UserModel,
    accessToken?: string,
    refreshToken?: string
  ) {
    this._currentUser = user;
    this._accessTokenForM365 = accessToken;
    this._refreshTokenForM365 = refreshToken;
  }

  onLogout() {
    this._currentUser = undefined;
    clearPersistedStore(this);
  }

  async fetchConfigSettings() {
    try {
      const res: M5DocResponse<ConfigDocModel> = await M5APIs.fetchDocById(
        "SVCDoc_1021261338730496",
        config.BUCKET_TASK!,
        "configs",
        {}
      );
      if (res.doc) {
        this._isPublic = res.doc?.userData?.value.isPublic;
      }
      console.log(this._isPublic);
    } catch (err) {
      console.log(err);
    }
  }
}
